import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import { Title } from './css';
import ErrorIcon from '../../assets/images/icon_error_messages.gif';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const ErrorMessages = ({ error }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        ERRORS_MESSAGES: { GENERIC_ERROR_HEADING },
        labels: { FORGOT_PASSWORD_PAGE_TITLE }
      }
    }
  } = localizedStrings;

  return (
    <>
      <Typography heading="h2" variant={{ size: 'h2' }} block>
        <div id="main-content-title">
          <Title>{FORGOT_PASSWORD_PAGE_TITLE}</Title>
        </div>
      </Typography>
      {error ? (
        <div id="error-message-content" style={{ display: 'block' }}>
          <div id="error-message-icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
          <div id="error-message-title">
            <Typography>{GENERIC_ERROR_HEADING}</Typography>
          </div>
          <div className="clear" />
          <div id="error-message-message">
            <Typography>
              {error}
              <br />
            </Typography>
          </div>
        </div>
      ) : null}
    </>
  );
};

ErrorMessages.propTypes = {
  error: PropTypes.bool.isRequired
};
export default ErrorMessages;
